export default class NoTripsException extends Error {
  constructor(message, identifier) {
    super(message);
    this.identifier = identifier;
  }
}
